//#region types
import { TextInputProps } from "models/propTypes/wintFormPropsTypes";
import cssExports from "theme/styles/main.module.scss";
//#endregion
//#region components
import BaseInput from "./baseInput";
import { FormControl } from "@mui/material";
//#endregion

function TextAreaInput(props: TextInputProps) {
  return (
    <FormControl fullWidth className={cssExports.inputFormControl}>
      <BaseInput {...props} type="text" multiline data-testid={`${props.name}TextAreaInput`} />
    </FormControl>
  );
}

export default TextAreaInput;
